// @flow
import type { AxiosPromise, AxiosInstance } from "axios";
import customParamSerializer from "@justpark/helpers/src/customParamSerializer/customParamSerializer";
import type { LatLngLiteral } from "../types";
import debug from "../helpers/debug";

const getWalkingDistance = (
  destination: LatLngLiteral,
  listingIds: Array<string | number>
): ((apiInstance: AxiosInstance) => AxiosPromise) => (apiInstance) => {
  debug("getWalkingDistance", destination, listingIds);
  return apiInstance.get("/v5/routing/walking", {
    params: {
      destination: `${destination.lat},${destination.lng}`,
      listing_ids: listingIds
    },
    timeout: 5000,
    paramsSerializer: customParamSerializer
  });
};

export default getWalkingDistance;
